import { Stack } from 'react-bootstrap';
import { Footer } from "@odmonorepo/core-components";
import SideNav from "./Components/SideNav/SideNav";
import Header from "./Components/Header/Header";
import { CobrandedHeader } from './Components/Header/CobrandedHeader';
import { Outlet } from '@tanstack/react-router';
import CheckoutFooter from './Components/Footer/CheckoutFooter';
import { LogoOnlyHeader } from './Components/Header/LogoOnlyHeader';
import { HeaderLogin } from './Components/Header/HeaderLogin';
import { ReactElement } from 'react';

interface AppLayoutProps {
  footer?: ReactElement
  sidebar?: ReactElement
  header?: ReactElement
  outlet?: ReactElement
}

export const AppLayout = ({sidebar, header, footer, outlet}: AppLayoutProps) => {
  return (
    <div
      className="d-flex flex-column flex-lg-row"
      style={{ minHeight: '100vh' }}
    >
      {sidebar}
      <div className="w-100 d-flex flex-column">
        <div className="w-100 d-flex justify-content-center p-5 flex-grow-1">
          <Stack style={{ maxWidth: '1050px', minWidth: 0, width: '100%' }} gap={5}>
            {header}
            {outlet || <Outlet />}
          </Stack>
        </div>
        <div className="w-100 mt-auto pt-5">
          {footer ? footer : <Footer />}
        </div>
      </div>
    </div>
  );
}

interface OutletProps {
  outlet?: ReactElement
}

export const AccountHomeLayout = ({outlet}: OutletProps) => <AppLayout sidebar={<SideNav/>} outlet={outlet}/>
export const CobrandedLayout = ({outlet}: OutletProps) => <AppLayout header={<CobrandedHeader/>} outlet={outlet}/>
export const LogoOnlyLayout = ({outlet}: OutletProps) => <AppLayout header={<LogoOnlyHeader/>} outlet={outlet}/>
export const HeaderLayout = ({outlet}: OutletProps) => <AppLayout header={<Header/>} outlet={outlet}/>
export const CheckoutLayout = ({outlet}: OutletProps) => <AppLayout header={<Header/>} footer={<CheckoutFooter/>} outlet={outlet}/>
export const LoginLayout = ({outlet}: OutletProps) => <AppLayout header={<HeaderLogin/>} outlet={outlet}/>
